<template>
    <div style="width:100%; height:100%;">
        <div class="title">
        <p>离心机轴振</p>
        </div>
        <div class="list">
        <div class="data"  v-for="(line, i) in variable3DS"
                :key="i">
                <div style="width:25%;height:50%;  display: flex; align-items: center;justify-content: center;">
          <span class="name">{{ line.alias }}</span>
        </div>
        <div style="width:25%;height:50%;  display: flex; align-items: center;justify-content:flex-start;">
          <span class="state" :style="{
                    color:
                      line.colour == 'green'
                        ? '#4DCB73'
                        : line.colour == 'red'
                        ? 'rgba(224, 32, 32, 1)'
                        : line.colour == 'yellow'
                        ? 'yellow'
                        : '',
                  }">{{line.value}} {{ line.unit }}</span>
                  </div>
        </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            variable3DS:Array
        },
        data() {
            return {
                recycleRecords: [
        {
          name: "一级轴振动",
          num:"40um",
          state: "正常",
        },
        {
          name: "二级轴振动",
          num:"90um",
          state: "故障",
        },
        {
          name: "三级轴振动",
          num:"68um",
          state: "异常",
        }
      ],
            }
        },
    }
</script>

<style  scoped>
*{
    margin: 0;
    padding: 0;
}
.title{
    width: 100%;
    height: 8%;
    background: url(../../assets/img/centrifuge/title.png) no-repeat;
    background-size: 100% 100%;
}
.title p{
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
   font-size: .8vw;
   color: white;
   margin-left:2vw;
}
.list{
    margin-top: 10.5%;
    width: 100%;
    height: 95%;  
}
.data{
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 17%;
    /* background-color: aqua; */
}
.name{
    color: white;
    font-size:1vw;
}
.state{
    color: white;
    font-size:1vw;
}
</style>